import { render, staticRenderFns } from "./AgreementSettings.vue?vue&type=template&id=6c4004fe"
import script from "./AgreementSettings.vue?vue&type=script&lang=js"
export * from "./AgreementSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports